module.exports = __webpack_public_path__ + "img/Red-R-1@2x.a6a93a64.png";